// extracted by mini-css-extract-plugin
module.exports = {"successContainer":"SuccessCard_successContainer__7JNcQ","noModal":"SuccessCard_noModal__1G-cO"};